import React, {useState, useMemo} from 'react'
import PropTypes from 'prop-types'
import {PaginatedGridDisplay} from 'hec/components/paginated-grid-display'
import {Blocks} from '@builder.io/sdk-react'

export const CustomGrid = (props) => {
    const {attributes, builderBlock, articleCards = [], itemsToShowPerLoad} = props

    const [currentPage, setCurrentPage] = useState(1)
    const [showAll, setShowAll] = useState(false)

    const displayedArticles = useMemo(() => {
        if (showAll) return articleCards
        return articleCards?.slice(0, currentPage * itemsToShowPerLoad)
    }, [articleCards, showAll, currentPage, itemsToShowPerLoad])

    const displayedArticlesCount = displayedArticles?.length
    const isLastPage = displayedArticlesCount >= articleCards?.length

    const showNextEntries = () => {
        const nextPage = currentPage + 1
        const hasMoreToShow = nextPage * itemsToShowPerLoad <= articleCards.length

        if (hasMoreToShow && !isLastPage) {
            setCurrentPage(nextPage)
        }
    }

    const displayedArticleBlocks = displayedArticles?.map((article, index) => (
        <div key={index}>
            <Blocks
                path={`component.options.articleCards.${index}.content`}
                blocks={[article]}
                parent={builderBlock?.id}
                data-testid="customGrid-Blocks"
            />
        </div>
    ))

    const displayedItemsText = `Showing ${displayedArticlesCount} of ${articleCards?.length} articles`

    return (
        <PaginatedGridDisplay
            attributes={attributes}
            displayedItems={displayedArticleBlocks}
            displayedItemsText={displayedItemsText}
            showNextEntries={showNextEntries}
            showAllEntries={() => setShowAll(true)}
            showAll={showAll}
            isLastPage={isLastPage}
            data-testid="customGrid-PaginatedGridDisplay"
        />
    )
}

CustomGrid.propTypes = {
    attributes: PropTypes.object,
    builderBlock: PropTypes.object,
    articleCards: PropTypes.arrayOf(PropTypes.object),
    customGrid: PropTypes.bool,
    itemsToShowPerLoad: PropTypes.number
}
